// Estimated story (video) generation time by target duration in seconds.
// 30s → 4 min, 60s → 5 min, 90s → 7–10 min, 3 min → 12–15 min, 5 min → 17–20 min.
export const getStoryGenerationEstimate = (durationSeconds) => {
  const d = Number(durationSeconds) || 0;
  if (d <= 30) return "4 minutes";
  if (d <= 60) return "5 minutes";
  if (d <= 90) return "7–10 minutes";
  if (d <= 180) return "12–15 minutes";
  return "17–20 minutes";
};

// Upper-bound of the same estimate, in seconds — used to pace the progress bar so it
// reaches ~90% around the estimated time (then waits for real completion), instead of
// a hardcoded 15-minute pace for every duration.
export const getStoryGenerationEstimateSeconds = (durationSeconds) => {
  const d = Number(durationSeconds) || 0;
  if (d <= 30) return 4 * 60;    // ~4 min
  if (d <= 60) return 5 * 60;    // ~5 min
  if (d <= 90) return 10 * 60;   // 7–10 min
  if (d <= 180) return 15 * 60;  // 12–15 min
  return 20 * 60;                // 17–20 min
};
